/*
 * @Description:
 * @Date: 2025-05-20 13:46:15
 */
import http from '@/utils/http/axios';
import {
  ActOpenInfo,
  GetCategoryList,
  GetRegionList,
  EntpActOpenDetail,
  BankList,
  EntpActOpen,
  SendWithdrawMsg,
  SubmitCashOut,
  QuerySupplierWithdrawList,
  RechargeInfo,
  RechargeRecordList,
  SelectTransStatementList,
  SelectTransStatementListParams,
  GetEnterpriseAccountBalance,
  GetEnterpriseBankInfo,
  GetSupplierWithdrawAmount,
  GetEnterpriseCupBankInfo,
  SaveEnterpriseCupBankInfo
} from './types';
import {
  pagerTranslator,
  backEndDatetimerangetranslator
} from '@data-source/common/translators';
import { entpActOpenDetailTranslator } from './translators';

enum Api {
  queryByCode = '/front-end/common/queryByCode', // 查询所有支付通道
  actOpenInfo = '/front-end/act/api/v1/actOpenInfo', // 查询企业通道开通状态
  getCategoryList = '/front-end/act/api/v1/getCategoryList', // 查询行业类别
  getRegionList = '/front-end/act/api/v1/getRegionList', // 查询省市县
  entpActOpenDetail = '/front-end/act/api/v1/entpActOpenDetail', // 账户详情
  bankList = '/front-end/act/api/v1/bankList', // 获取开户行
  entpActOpen = '/front-end/act/api/v1/entpActOpen', // 企业开户
  sendWithdrawMsg = '/front-end/enterprise/cashout/api/v1/sendWithdrawMsg', // 提现短信
  submitCashOut = '/front-end/enterprise/cashout/api/v1/submitCashOut', // 确认提现
  querySupplierWithdrawList = '/front-end/enterprise/cashout/api/v1/querySupplierWithdrawList', // 供应商项目订单（提现选择列表）
  rechargeInfo = '/front-end/fe/enterprise/transaction/api/v1/rechargeInfo', // 充值信息
  rechargeRecordList = '/front-end/fe/enterprise/transaction/api/v1/rechargeRecordList', // 充值列表
  selectTransStatementList = '/front-end/fe/enterprise/transaction/api/v1/selectTransStatementList', // 企业交易列表-查询
  exportTranStatementList = '/front-end/fe/enterprise/transaction/api/v1/exportTranStatementList', // 企业交易列表-导出
  downloadVoucher = '/front-end/fe/enterprise/transaction/api/v1/downloadVoucher', // 企业交易列表-批量下载回执单
  getEnterpriseAccountBalance = '/front-end/api/v1/enterprise/transaction/getEnterpriseAccountBalance', // 企业账户余额
  getEnterpriseBankInfo = '/front-end/enterprise/cashout/api/v1/getEnterpriseBankInfo', // 企业提现时，显示提现户信息。
  getSupplierWithdrawAmount = '/front-end/enterprise/cashout/api/v1/getSupplierWithdrawAmount', // 供应商提现，选择列表数据，计算提现金额、可提现金额(手续费已返回，页面算)
  getEnterpriseCupBankInfo = '/front-end/enterprise/cup-bank/api/v1/cupBankInfo/:deptId', // 获取网银账户信息
  saveEnterpriseCupBankInfo = '/front-end/enterprise/cup-bank/api/v1/saveEnterpriseCupBankInfo' // 保存修改网银账户信息
}

const yApi = {
  // yapi: 1263
};

export const actOpenInfo: ActOpenInfo = () =>
  http.request(
    {
      url: Api.actOpenInfo,
      method: 'POST'
    },
    {
      ...yApi
    }
  );

export const getCategoryList: GetCategoryList = async params => {
  const resp = await http.request(
    {
      url: Api.getCategoryList,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return resp;
};
export const getRegionList: GetRegionList = params =>
  http.request(
    {
      url: Api.getRegionList,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
export const entpActOpenDetail: EntpActOpenDetail = async params => {
  const resp = await http.request(
    {
      url: Api.entpActOpenDetail,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
  return entpActOpenDetailTranslator(resp);
};
export const bankList: BankList = params =>
  http.request(
    {
      url: Api.bankList,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
export const entpActOpen: EntpActOpen = params =>
  http.request({
    url: Api.entpActOpen,
    method: 'POST',
    params
  });
export const sendWithdrawMsg: SendWithdrawMsg = () =>
  http.request({
    url: Api.sendWithdrawMsg,
    method: 'POST'
  });
export const submitCashOut: SubmitCashOut = params =>
  http.request(
    {
      url: Api.submitCashOut,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
export const querySupplierWithdrawList: QuerySupplierWithdrawList = params =>
  http.request(
    {
      url: Api.querySupplierWithdrawList,
      method: 'POST',
      params
    },
    { ...yApi }
  );
export const exportTranStatementList = (
  params: SelectTransStatementListParams
) =>
  http.download({
    url: Api.exportTranStatementList,
    method: 'POST',
    params: backEndDatetimerangetranslator(params, [
      'startCreateAt',
      'endCreateAt'
    ])
  });
export const downloadVoucher = (
  params: SelectTransStatementListParams & { zipName: string }
) =>
  http.request({
    url: Api.downloadVoucher,
    method: 'POST',
    params: backEndDatetimerangetranslator(params, [
      'startCreateAt',
      'endCreateAt'
    ])
  });
export const rechargeInfo: RechargeInfo = () =>
  http.request({
    url: Api.rechargeInfo,
    method: 'POST'
  });
export const rechargeRecordList: RechargeRecordList = params =>
  http.request({
    url: Api.rechargeRecordList,
    method: 'POST',
    params
  });
export const selectTransStatementList: SelectTransStatementList =
  async params => {
    const resp = await http.request(
      {
        url: Api.selectTransStatementList,
        method: 'POST',
        params: backEndDatetimerangetranslator(params, [
          'startCreateAt',
          'endCreateAt'
        ])
      },
      {
        ...yApi
      }
    );
    return pagerTranslator(resp);
  };
export const getEnterpriseAccountBalance: GetEnterpriseAccountBalance = () =>
  http.request(
    {
      url: Api.getEnterpriseAccountBalance,
      method: 'POST'
    },
    {
      ...yApi
    }
  );
export const getEnterpriseBankInfo: GetEnterpriseBankInfo = () =>
  http.request(
    {
      url: Api.getEnterpriseBankInfo,
      method: 'POST'
    },
    {
      ...yApi
    }
  );
export const getSupplierWithdrawAmount: GetSupplierWithdrawAmount = params =>
  http.request(
    {
      url: Api.getSupplierWithdrawAmount,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );

/**
 * 获取网银账户信息
 * @param deptId 网银账户id
 */
export const getEnterpriseCupBankInfo: GetEnterpriseCupBankInfo = params =>
  http.request(
    {
      url: Api.getEnterpriseCupBankInfo,
      method: 'GET',
      params
    },
    {
      ...yApi
    }
  );

/**
 * 保存/修改网银账户信息
 * @param params 网银账户信息
 */
export const saveEnterpriseCupBankInfo: SaveEnterpriseCupBankInfo = params =>
  http.request(
    {
      url: Api.saveEnterpriseCupBankInfo,
      method: 'POST',
      params
    },
    {
      ...yApi
    }
  );
